import type { MoveResponseDto } from '@/api/generated/api'
import { CardGrid } from './CardGrid'
import { MoveCard } from './MoveCard'

interface MovesSectionProps {
  moves?: MoveResponseDto[]
}

export function MovesSection({ moves = [] }: MovesSectionProps) {
  return (
    <CardGrid
      items={moves}
      emptyState={{
        icon: (
          <svg
            className="h-8 w-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        ),
        emoji: '🥋',
        title: 'No moves yet',
        description: 'Tap + to save a move.',
      }}
      renderCard={move => <MoveCard move={move} />}
      getItemLink={move => `/moves/${move.id}`}
      getItemKey={move => move.id}
    />
  )
}
